import React, { memo, useState, useRef, useCallback } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  Card,
  Text,
  Space,
  IconClose,
  IconEdit,
  IconButton,
  IconDrag,
} from '@redlink/components/atoms';
import { TextInput } from '@redlink/components/molecules';

export const Separator = memo(
  ({ item: { title }, onEdit, onDelete, dragHandle }) => {
    const [isEditMode, setisEditMode] = useState(false);
    const [value, setValue] = useState(title);
    const { styles, colors } = useStyle();
    const inputRef = useRef(null);

    const changeEditMode = useCallback(async () => {
      await setisEditMode(true);
      inputRef.current.focus();
    }, []);

    return (
      <Card style={styles.container}>
        {dragHandle && (
          <>
            <div {...dragHandle}>
              <IconDrag />
            </div>
            <Space size={15} />
          </>
        )}
        <IconButton transparent onPress={changeEditMode}>
          <IconEdit color={colors.black} />
        </IconButton>
        <Space />
        <IconButton transparent onPress={onDelete}>
          <IconClose color={colors.black} />
        </IconButton>
        <View style={styles.textContainer}>
          {isEditMode ? (
            <TextInput
              ref={inputRef}
              onBlur={() => {
                onEdit(value);
                setisEditMode(false);
              }}
              style={styles.textInput}
              textStyle={styles.textInputText}
              value={value}
              onChangeText={(value) => setValue(value)}
            />
          ) : (
            <Text style={styles.titleText}>{value}</Text>
          )}
        </View>
      </Card>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  container: {
    flex: 1,
    maxHeight: 48,
    flexDirection: 'row',
    alignItems: 'center',
  },
  textContainer: {
    flex: 1,
  },
  titleText: {
    fontWeight: '500',
    fontSize: 14,
    color: colors.gray23,
    textAlign: 'right',
  },
  textInput: {
    marginStart: 40,
    maxHeight: 38,
    borderBottomWidth: 0,
    backgroundColor: colors.gray7,
  },
  textInputText: {
    fontSize: 14,
  },
}));
